import { SOMATIC_KEYS } from "src/routes/onboarding/shared";
import styles from "./styles.module.scss";
import { Button } from "@common/button";
import { useNavigate } from "react-router";
import { trackUserEvent } from "src/utils/updateDataLayer";
import { useOnboardingTexts } from "src/routes/onboarding/shared/hooks/useOnboardingTexts";

export const Newsletter = () => {
  const navigate = useNavigate();

  const { getSectionText } = useOnboardingTexts();

  const title = getSectionText("email_consent").title;

  const handleNextStep = (value) => {
    const selectedOption = value
      ? "SURE, I'M IN!"
      : "I DON'T WANT TO RECEIVE TIPS OR UPDATES";

    localStorage.setItem(SOMATIC_KEYS.newsletter, JSON.stringify(value));
    navigate("/name");
    trackUserEvent?.(selectedOption, {
      screenId: "Email_consent",
      screenTitle: title,
    });
  };

  return (
    <div className={styles.container} id="breakdown">
      <div className={styles.content}>
        <h2>{title}</h2>
      </div>
      <Button onClick={() => handleNextStep(true)}>SURE, I'M IN!</Button>
      <button className={styles.decline} onClick={() => handleNextStep(false)}>
        <p>I DON'T WANT TO RECEIVE TIPS OR UPDATES</p>
      </button>
    </div>
  );
};
